<template>
    <div class="obs-modal-container" :class="{ 'has-itens': products && products.length > 0 }">
        <div class="modal-form-container">
            <div class="title-box">
                <h2>{{ getString('Adicionar Produto') }}</h2>
            </div>
            <template v-if="products && products.length > 0">
                <div class="products-container">
                    <div class="products" v-for="(product, key) in products" :key="key">
                        <div class="image-container">
                            <img v-if="product.productImages && product.productImages.large != null"
                                :src="getImagesURL(product, 'productImages', 'large')" alt="">
                            <img v-else :src="noImageSrc">
                        </div>

                        <div class="name-container" v-if="product.productName">
                            <h2 v-text="getProductLanguage(product, 'productName')"></h2>
                            <div class="details-container" v-if="product.productDescription">
                                <p v-text="'Descrição: ' + getProductLanguage(product, 'productDescription')"></p>
                            </div>
                        </div>

                        <div class="price-container">
                            <span class="price" v-text="getProdPrice(product)"></span>
                            <QuantityControl :quantity="product.quantity" @circleBtnRemove="decreaseQtty(key)"
                                @circleBtnAdd="increaseQtty(key)"></QuantityControl>
                        </div>
                    </div>
                </div>
                <div class="more-products-container" :class="{ 'not-found': notFound }">
                    <img :src="barCodeImg">
                    <span
                        v-text="notFound ? this.getString('produto_nao_encontrado') : getString('apresente_novamente')"></span>
                </div>
            </template>
            <template v-else>
                <div class="no-product-container" :class="{ 'not-found': notFound }">
                    <img :src="barCodeImg">
                    <span
                        v-text="notFound ? this.getString('produto_nao_encontrado') : getString('apresente_cod_barras')"></span>
                </div>
            </template>
        </div>
        <div class="total-container" v-if="products && products.length > 0">
            <div class="left">
                <span>Subtotal: </span>
                <span>Total: </span>
            </div>
            <div class="right">
                <span v-text="formatMoney(subTotal)"></span>
                <span v-text="formatMoney(total)"></span>
            </div>
        </div>
        <div class="prod-item-footer">
            <DefaultButton :text="getString('cancelar')" outlined="true" @defaultBtnClick="cancel"></DefaultButton>
            <DefaultButton v-if="products && products.length > 0"
                :text="wait ? getString('aguarde') : getString('confirmar')" :disabled="wait"
                :class="{ 'disabled': wait }" @defaultBtnClick="addProductsToComanda"></DefaultButton>
        </div>
        <ProductBarcodeScanner @handleBarCode="handleBarCode"></ProductBarcodeScanner>
    </div>
</template>

<script>
import Util from '@/assets/libs/util'
import DefaultButton from '@/components/DefaultButton'
import LocaleController from '@/assets/controllers/LocaleController'
import keyboardLayout from '@/assets/libs/keyboardLayout'
import requestModule from '@/assets/libs/requestModule.js'
import QuantityControl from '@/components/QuantityControl'
import CartController from '../assets/controllers/CartController'
import ProductBarcodeScanner from './ProductBarcodeScanner.vue'
import SaleController from '../assets/controllers/SaleController'
import ProductController from '../assets/controllers/ProductController'
import DifferentiatedPricesController from '../assets/controllers/DifferentiatedPricesController'
export default {
    name: 'AddProductModal',
    components: {
        DefaultButton,
        QuantityControl,
        ProductBarcodeScanner
    },
    props: {
        pendingComandaNumber: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            product: {},
            products: [],
            subTotal: 0,
            total: 0,
            barCodeProduct: '',
            comanda: [],
            inputElement: null,
            layout: keyboardLayout.TEXT,
            noImageSrc: null,
            notFound: false,
            wait: false,
            junk: require('../../static/icons/junk-icon.png'),
            barCodeImg: require('../../static/icons/ic-codigo-barras.png'),
            comandaAberta: false
        }
    },
    mounted () {
        this.noImageSrc = Util.getConfigImage('noImage') ? Util.getConfigImage('noImage') : this.junk
        this.comanda = Util.deepCopy(CartController.getComandasAgregadas())
    },
    methods: {
        getString: function (key) {
            return LocaleController.getString(key)
        },
        /* getImagesURL: function () {
            return Util.getLocalConfigs('urlIMGOdhenInterface')
        }, */
        getImagesURL: function (prod, prop, size) {
            return Util.getImagesUrl(prod, prop, size)
            // return Util.getLocalConfigs('urlIMGOdhenInterface')
        },
        modalCancel: function () {
            this.$emit('obsModalClose', this.obsModalProd)
        },
        modalConfirm: function () {
            this.$emit('obsModalClose', this.obsModalProd)
        },
        formatMoney: function (price) {
            return Util.formatMoney(price)
        },
        getProductLanguage: function (product, index) {
            return LocaleController.getIndexLanguages(product, index)
        },
        getProduct: async function (barCode) {
            this.wait = true
            const generalInfo = Util.getGeneralInfo(false)
            let payload = {
                ...generalInfo,
                productBarCode: barCode
            }
            let productRaw = await requestModule.postRequest('menu/getProduct', payload)
                .then(r => r && r.data)
                .catch(e => {
                    console.log(e)
                    return false
                })
            if (!productRaw || (productRaw && productRaw.length === 0)) {
                this.notFound = true
                setTimeout(() => {
                    this.text = this.products && this.products.length > 0 ? this.getString('apresente_novamente') : this.getString('apresente_cod_barras')
                    this.notFound = false
                }, 2000)
                this.wait = false
                return false
            }

            productRaw.quantity = productRaw.quantity || 1
            let diffPrice = DifferentiatedPricesController.getDiffPrice(productRaw.productCode, false, productRaw)
            if (diffPrice) {
                productRaw.price = diffPrice
            }
            this.products.push(productRaw)
            this.calculateSubTotal()
            setTimeout(() => {
                let lastProduct = document.querySelectorAll('.products')
                if (lastProduct && lastProduct.length > 0) {
                    lastProduct[lastProduct.length - 1].scrollIntoView({ behavior: 'smooth' })
                }
            }, 200)
            this.wait = false
        },
        decreaseQtty: function (key) {
            if (this.products[key] && this.products[key].quantity > 1) {
                this.products[key].quantity -= 1
            }
            this.calculateSubTotal()
        },
        increaseQtty: function (key) {
            if (this.products[key]) {
                this.products[key].quantity += 1
            }
            this.calculateSubTotal()
        },
        getProdPrice: function (product) {
            return this.formatMoney(product.price * product.quantity)
        },
        calculateSubTotal: function () {
            const automaticServiceTax = Util.getLocalConfigs('automaticServiceTax') === true
            this.subTotal = SaleController.calculateSubTotal(this.products)
            this.total = Util.safeDecimalCalc(CartController.getTotalPriceAsFloat(!automaticServiceTax, true), this.subTotal, '+')
            this.$forceUpdate()
        },
        handleBarCode: function (barcode) {
            if (!barcode || this.wait) {
                return false
            }
            this.getProduct(barcode)
        },
        addProductsToComanda: async function () {
            if (!this.products || this.products.length === 0) {
                Util.showInfoModal('Nenhum produto para adicionar.')
                return
            }

            this.wait = true
            let comandaNumber = ''
            let saleCode = ''
            try {
                if (this.comanda && this.comanda.length > 0 && this.comanda[0] && this.comanda[0].saleDescription) {
                    comandaNumber = this.comanda[0].saleDescription
                    saleCode = this.comanda[0].saleCode
                    this.comandaAberta = true
                } else {
                    comandaNumber = String(this.pendingComandaNumber || '').trim()
                    this.comandaAberta = false
                }

                if (!comandaNumber) {
                    Util.showInfoModal('Número da comanda não informado.')
                    return
                }

                if (!this.comandaAberta) {
                // 1. Buscar status
                    let statusResult = await SaleController.getStatusTable(comandaNumber)
                    let statusId = null

                    if (statusResult && statusResult.data && statusResult.data.status) {
                        statusId = statusResult.data.status.statusId
                        saleCode = statusResult.data.status.saleCode
                    }

                    if (process.env.NODE_ENV !== 'production') {
                        console.log('[AddProductModal] Status:', statusId === 2 ? 'Aberta' : 'Disponível', 'SaleCode:', saleCode)
                    }
                    // 2. Abrir comanda se necessário
                    if (statusId === 2) {
                        const openResult = await SaleController.openComanda(comandaNumber, 1, '')
                        if (!openResult || openResult.error) {
                            Util.showInfoModal('Erro ao abrir comanda: ' + ((openResult && openResult.message) || openResult.message || 'Erro desconhecido'))
                            return
                        }

                        if (!openResult.data || !openResult.data[0] || !openResult.data[0].saleCode) {
                            Util.showInfoModal('Resposta de abertura da comanda inválida.')
                            return
                        }

                        saleCode = openResult.data[0].saleCode
                        if (process.env.NODE_ENV !== 'production') {
                            console.log('[AddProductModal] Comanda aberta → SaleCode:', saleCode)
                        }
                    } else if (statusId === 1 && saleCode) {
                        if (process.env.NODE_ENV !== 'production') {
                            console.log('[AddProductModal] Comanda já aberta.')
                        }
                    } else {
                        Util.showInfoModal('Status da comanda inválido: ' + statusId)
                        return
                    }
                    if (!saleCode) {
                        Util.showInfoModal('Não foi possível obter saleCode.')
                        return
                    }
                }

                // 3. Adicionar produtos
                const comandaTarget = {
                    saleCode: saleCode,
                    saleDescription: comandaNumber
                }

                if (process.env.NODE_ENV !== 'production') {
                    console.log('[AddProductModal] Enviando produtos para comanda...')
                }

                const addResult = await SaleController.addPtoductsToComanda(this.products, comandaTarget)

                if (!addResult) {
                    Util.showInfoModal('Nenhuma resposta do servidor ao adicionar produtos.')
                    return
                }

                if (addResult.error) {
                    Util.showInfoModal(addResult.message || 'Erro ao adicionar os produtos.')
                    return
                }

                if (!addResult.data) {
                    Util.showInfoModal('Resposta do add produtos veio sem "data".')
                    return
                }

                if (addResult.data.length === 0) {
                    Util.showInfoModal('Produtos não foram adicionados (lista vazia).')
                    return
                }

                if (process.env.NODE_ENV !== 'production') {
                    console.log('[AddProductModal] Produtos adicionados com sucesso!')
                }
                // 4. Recarregar comanda
                await ProductController.getProductsFromComanda(comandaNumber, true)

                // Sucesso
                this.products = []
                this.subTotal = 0
                this.total = 0
                this.$emit('closeAddProductModal', true)
            } catch (error) {
                console.error('ERRO NO ADD PRODUCT MODAL: ', error)
                Util.showInfoModal('Erro inesperado ao adicionar produtos: ' + (error && error.message ? error.message : error))
            } finally {
                this.wait = false
            }
        },
        cancel: function () {
            this.$emit('closeAddProductModal', false)
        },
        confirmAndClose: function () {
            this.$emit('closeAddProductModal', true)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang='less'>
@import (reference) url("../assets/common.less");

.obs-modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto 75px;
    background: @white;
    border-radius: 25px;
    z-index: 2;
    box-shadow: 5px 5px 5px rgba(0, 0, 0, 0.1);
    height: max-content;
    display: grid;
    grid-template-rows: 1fr 180px;

    &.has-itens {
        grid-template-rows: 1fr 150px 180px;
    }

    .modal-form-container {
        position: relative;
        overflow: hidden auto;
        display: flex;
        flex-direction: column;

        .title-box {
            background-color: @primary-color;
            height: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 25px 25px 0px 0px;
            // margin-bottom: 15px;

            h2 {
                color: @white;
                margin: auto;
                font-size: 40px;
            }
        }

        .products-container {
            overflow: auto;
            max-height: 800px;

            .products {
                display: flex;
                align-items: center;
                flex-direction: row;
                margin-bottom: 10px;
                border-bottom: solid 1px rgba(0, 0, 0, 0.5);
                padding: 5px;
                justify-content: space-between;
                &:last-of-type {
                    border: none;
                }

                .image-container {
                    padding: 20px;

                    img {
                        height: 250px;
                        object-fit: scale-down;
                        margin: auto;
                        display: block;
                        width: 250px;
                    }
                }

                .name-container {
                    // margin: auto;
                    text-align: center;
                    display: block;
                    color: @primary-color;
                    padding: 0 5px;
                    font-size: 22px;

                    .details-container {
                        color: black;
                        font-size: 25px;
                        text-align: left;
                        padding: 0 10px;
                        max-height: 100px;
                        overflow: auto;

                        p {
                            padding: 0;
                        }
                    }
                }

                .price-container {
                    // background-color: @primary-light;
                    display: flex;
                    flex-direction: column-reverse;
                    justify-content: space-around;
                    align-items: center;
                    // flex-wrap: nowrap;
                    height: 250px;
                    padding: 20px;

                    span {
                        font-size: 40px;
                    }
                }
            }
        }

        .more-products-container {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            padding: 10px 30px;
            background-color: rgba(167, 167, 167, 0.3);

            img {
                height: 150px;
                object-fit: scale-down;
                margin: auto;
                display: block;
                width: 150px;
            }

            span {
                font-size: 30px;
                text-align: center;
                padding: 20px;
                margin: auto;
            }

            &.not-found {
                background-color: rgba(253, 25, 25, 0.3);

                span {
                    color: rgb(228, 0, 0)
                }
            }
        }

        .no-product-container {
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            padding: 35px 20px;
            align-items: center;

            img {
                max-width: 350px;
            }

            span {
                font-size: 35px;
                text-align: center;
            }

            &.not-found {
                background-color: rgba(253, 25, 25, 0.3);

                span {
                    color: rgb(228, 0, 0)
                }
            }
        }
    }

    .total-container {
        padding: 20px;
        background-color: @primary-light;
        display: flex;
        align-items: center;
        justify-content: center;

        .left {
            display: flex;
            flex-direction: column;
            align-items: center;
        }

        .right {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        }

        span {
            padding: 0 20px;
            font-size: 35px;
        }
    }

    .prod-item-footer {
        position: relative;
        display: flex;
        justify-content: space-between;
        background: rgba(0, 0, 0, 0.1);
        height: 180px;
        border-radius: 0 0 25px 25px;

        button {
            position: relative;
            display: block;
            margin: auto;

            &.disabled {
                pointer-events: none
            }
        }
    }
}

@media (min-width: 699px) and (max-width: 1025px) {
    //@tablet

    .obs-modal-container {
        // height: calc(100vh - 150px);
        grid-template-rows: 1fr 130px;
        margin: auto 50px;

        &.has-itens {
            grid-template-rows: 1fr 110px 130px;
        }

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    color: @white;
                    margin: auto;
                    font-size: 30px;
                }
            }

            .products-container {
                overflow: auto;
                max-height: 600px;

                .products {
                    .image-container {
                        padding: 10px;

                        img {
                            height: 150px;
                            width: 150px;
                        }
                    }

                    .name-container {
                        padding: 0 5px;
                        font-size: 16px;

                        .details-container {
                            font-size: 16px;
                        }
                    }

                    .price-container {
                        height: 150px;
                        padding: 10px;

                        span {
                            font-size: 25px;
                        }
                    }
                }
            }

            .more-products-container {
                padding: 5px 15px;

                img {
                    height: 120px;
                    width: 120px;
                }

                span {
                    font-size: 20px;
                    text-align: center;
                }
            }

            .no-product-container {
                padding: 35px 15px;

                img {
                    max-width: 180px;
                }

                span {
                    font-size: 30px;
                    text-align: center;
                    padding: 0 15px;
                }
            }
        }

        .total-container {
            padding: 20px;

            span {
                padding: 0 20px;
                font-size: 25px;
            }
        }

        .prod-item-footer {
            height: 130px;
        }
    }

    #keyboard {
        .keyboard;
        position: fixed;
        bottom: 0;
        max-width: 760px;
        font-size: 20px;
    }
}

@media (max-width: 698px) {
    // Gertec SK210

    .obs-modal-container {
        grid-template-rows: 1fr 70px;
        margin: auto 50px;
        border-radius: 20px;

        &.has-itens {
            grid-template-rows: 1fr 50px 70px;
        }

        .modal-form-container {
            .title-box {
                height: 50px;
                border-radius: 20px 20px 0 0;

                h2 {
                    font-size: 22px;
                }
            }

            .products-container {
                overflow: auto;
                max-height: 300px;

                .products {
                    padding: 3px;
                    margin-bottom: 2px;

                    .image-container {
                        padding: 5px;

                        img {
                            height: 75px;
                            width: 75px;
                        }
                    }

                    .name-container {
                        padding: 0;
                        font-size: 12px;

                        .details-container {
                            font-size: 12px;
                        }
                    }

                    .price-container {
                        height: 75px;
                        padding: 5px;

                        span {
                            font-size: 20px;
                        }
                    }
                }
            }

            .more-products-container {
                padding: 3px 7px;

                img {
                    height: 70px;
                    width: 70px;
                }

                span {
                    font-size: 14px;
                    text-align: center;
                }
            }

            .no-product-container {
                padding: 35px 15px;

                img {
                    max-width: 85px;
                }

                span {
                    font-size: 20px;
                    text-align: center;
                    padding: 0 15px;
                }
            }
        }

        .total-container {
            padding: 5px;

            span {
                padding: 0 10px;
                font-size: 14px;
            }
        }

        .prod-item-footer {
            height: 70px;
            border-radius: 0 0 20px 20px;
        }
    }
}

@media (orientation: landscape) and (min-width: 1000px) {
    .obs-modal-container {
        // height: calc(100vh - 150px);
        grid-template-rows: 1fr 110px;
        margin: auto 130px;

        &.has-itens {
            grid-template-rows: 1fr 110px 110px;
        }

        .modal-form-container {
            .title-box {
                height: 100px;

                h2 {
                    color: @white;
                    margin: auto;
                    font-size: 28px;
                }
            }

            .products-container {
                overflow: auto;
                max-height: 250px;
                margin-bottom: 5px;
                .products {
                    .image-container {
                        padding: 5px;
                        img {
                            height: 110px;
                            width: 150px;
                        }
                    }

                    .name-container {
                        padding: 0 5px;
                        font-size: 16px;

                        .details-container {
                            font-size: 16px;
                        }
                    }

                    .price-container {
                        height: 110px;
                        padding: 10px;

                        span {
                            font-size: 22px;
                        }
                    }
                }
            }

            .more-products-container {
                padding: 5px 15px;

                img {
                    height: 120px;
                    width: 120px;
                }

                span {
                    font-size: 20px;
                    text-align: center;
                }
            }

            .no-product-container {
                padding: 35px 25px;

                img {
                    max-width: 160px;
                }

                span {
                    font-size: 28px;
                    text-align: center;
                    padding: 0 15px;
                }
            }
        }

        .total-container {
            padding: 20px;

            span {
                padding: 0 20px;
                font-size: 25px;
            }
        }

        .prod-item-footer {
            height: 110px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/AddProductModal.vue